module.exports = __webpack_public_path__ + "static/img/oprCt_bg_06.57f58932.svg";